import {booleanAttribute, Directive, ElementRef, Input, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {Subscription} from 'rxjs';
import {CurrencyPipe} from '@angular/common';
import {TrsService} from '@core-app/services/trs.service';

@Directive({
    selector: '[coreFinancial]'
})
export class CoreFinancialDirective implements OnInit, OnDestroy {
    @Input({transform: booleanAttribute}) coreFinancial?: boolean = true;
    @Input() formatAsCurrency?: boolean = true;

    private originalContent: string | null = null;
    private sub: Subscription | undefined;

    constructor(
        private el: ElementRef,
        private renderer: Renderer2,
        private trsService: TrsService,
        private currencyPipe: CurrencyPipe,
    ) {
    }

    ngOnInit(): void {
        const nativeEl = this.el.nativeElement;
        this.originalContent = this.el.nativeElement.textContent;

        this.renderer.addClass(nativeEl, 'financial-transition');

        this.sub = this.trsService.getFiguresToggleState$().subscribe((hide: boolean) => {
            const content: string | undefined = this.originalContent?.trim();
            const numericValue: number = content ? parseFloat(content.replace(/[^0-9.-]/g, '')) : NaN;

            this.renderer.addClass(nativeEl, 'hidden');

            setTimeout(() => {
                if (hide && this.coreFinancial) {
                    this.renderer.setProperty(this.el.nativeElement, 'textContent', '$xxx');
                } else {
                    if (!isNaN(numericValue) && this.formatAsCurrency) {
                        if (numericValue === 0) {
                            this.renderer.setProperty(this.el.nativeElement, 'textContent', '-');
                        } else {
                            const formatted = this.currencyPipe.transform(numericValue, 'USD', 'symbol', '1.2-2');
                            this.renderer.setProperty(this.el.nativeElement, 'textContent', formatted ?? '-');
                        }
                    } else {
                        this.renderer.setProperty(this.el.nativeElement, 'textContent', this.originalContent);
                    }
                }

                this.renderer.removeClass(nativeEl, 'hidden');

            }, 200);
        });
    }

    ngOnDestroy(): void {
        this.sub?.unsubscribe();
    }

}
